export const transitions = {
  REQUEST_PAYMENT: 'transition/request-payment',
  CONFIRM_PAYMENT: 'transition/confirm-payment',
  EXPIRE_PAYMENT: 'transition/expire-payment',
};

export const states = {
  INITIAL: 'initial',
  PENDING_PAYMENT: 'pending-payment',
  COMPLETED: 'completed',
  PAYMENT_EXPIRED: 'payment-expired',
};

export const graph = {
  id: 'extra-fees/release-1',

  initial: states.INITIAL,

  states: {
    [states.INITIAL]: {
      on: {
        [transitions.REQUEST_PAYMENT]: states.PENDING_PAYMENT,
      },
    },
    [states.PENDING_PAYMENT]: {
      on: {
        [transitions.CONFIRM_PAYMENT]: states.COMPLETED,
        [transitions.EXPIRE_PAYMENT]: states.PAYMENT_EXPIRED,
      },
    },
    [states.COMPLETED]: { type: 'final' },
  },
};

export const isRelevantPastTransition = transition => {
  return [].includes(transition);
};

export const isPrivileged = transition => {
  return [transitions.REQUEST_PAYMENT].includes(transition);
};

export const isCompleted = transition => {
  return [transitions.CONFIRM_PAYMENT].includes(transition);
};

export const isRefunded = transition => {
  return false;
};

export const statesNeedingProviderAttention = [];
